import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "font-size": "20px",
    "margin": "20px 0 0 20px"
  }
};
const _hoisted_2 = {
  style: {
    "margin-top": "10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createTextVNode(" 上传文件 ", -1)), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.selectImage && $options.selectImage(...args))
  }, "选择图片"), _createElementVNode("input", {
    ref: "fileInput",
    type: "file",
    accept: "image/*",
    style: {
      "display": "none"
    },
    onChange: _cache[1] || (_cache[1] = (...args) => $options.handleFileChange && $options.handleFileChange(...args))
  }, null, 544), _createElementVNode("div", _hoisted_2, " 图片访问链接: " + _toDisplayString($data.imageUrl), 1)]);
}